export default {
  hero_label: 'AI Transformation for Japan',
  hero_headline_1: 'Empowering Japanese businesses',
  hero_headline_2: 'through AI transformation',
  hero_cta_services: 'Our Services',
  hero_cta_contact: 'Contact Us',
  hero_scroll: 'Scroll',

  service_heading: 'Services',
  service_heading_en: 'SERVICE',
  service_lead_title: 'End-to-End Consulting that Connects AI with Every Business Function',
  service_lead_desc: 'We combine AI with every business domain to deliver end-to-end consulting for transformation and growth.\nThrough our AIX business we cover every phase from strategy to execution, solving client challenges and leading them to success.',
  service_cta: 'Learn More About Our Services',
  service_card_learn_more: 'Learn More',
  service_tab_assigned_prefix: 'We can help you with your',
  service_tab_assigned_suffix: '',
  service_issues_title: 'Are You Facing These Challenges?',
  service_issues_contact: 'Contact Us',

  issues: [
    { label: 'Need an AI strategy', service: 'consulting' },
    { label: 'Struggling to make DX progress', service: 'consulting' },
    { label: 'Falling behind on AI adoption', service: 'consulting' },
    { label: 'Launching an AI business', service: 'consulting' },
    { label: 'AI operations are hard to manage', service: 'manager' },
    { label: 'Unable to analyze data', service: 'manager' },
    { label: 'Need automation', service: 'manager' },
    { label: 'Low AI literacy in the organization', service: 'training' },
    { label: 'Lacking in-house AI know-how', service: 'training' },
    { label: 'AI talent gap', service: 'training' },
  ],

  philosophy_1: 'AIX Means Connecting AI to Real Business Value',
  philosophy_2: 'We do not treat AI as merely a tool,\nbut transform it into a driver of competitive advantage, productivity, and business value.',
  philosophy_3: 'AIX is AI transformation.\nBy connecting AI to real business value, we drive enterprise and industry-wide change.',
  philosophy_cta_1: 'Our',
  philosophy_cta_2: 'Philosophy',

  member_heading: 'Team',
  member_heading_en: 'MEMBER',
  member_desc: 'A team of professionals transforming Japan with AI.',
  member_cta: 'Meet the Team',


  achievements_heading: 'Track Record',
  achievements_heading_en: 'TRACK RECORD',
  achievements_desc: 'From large listed companies to startups, we provide best-fit strategy building and execution support across all industries.',
  achievements_note: '*Only some clients who have given permission to display their logos are shown.',
  achievements_cases_cta: 'View Case Studies',
  achievements_stats_title: 'Outcomes Our Clients Achieved',
  achievements_stats_note: '*Calculated based on surveys of client companies and project data (FY2025 results).',
  stats_efficiency_label: 'Avg. Operational Efficiency Gain',
  stats_efficiency_desc: 'Average reduction in\nwork hours after AI adoption',
  stats_cost_label: 'Avg. Cost Reduction Rate',
  stats_cost_desc: 'Average reduction in\noperational costs via AI',
  stats_retention_label: 'Project Retention Rate',
  stats_retention_desc: 'Percentage of clients\nwho continue support post-introduction',
};